export const hideFilterBlock = (
  labelSelector: string,
  innerWidth: number,
  filterGroupIndex: number
) => {
  const labelElement = document.querySelector(labelSelector + filterGroupIndex);

  // Добавлено ограничение, т.к. в Collapse (w <= 950px)
  // эта логика работает немного иначе
  if (innerWidth > 950) {
    return (labelElement as HTMLElement)?.click();
  }
};
